import change from "../assets/about/1.png";
import experts from "../assets/about/2.png";
import exposure from "../assets/about/3.png";
import rewards from "../assets/about/4.png";
import homeTopBackground from "../assets/header/HometopBg.jpeg";
import homeBottomBackground from "../assets/header/HomebottomBg.jpeg";
import EventTopBackground from "../assets/header/EventstopBg.jpeg";
import faqTopBackground from "../assets/header/FaqtopBg.jpeg";
import faqBottomBackground from "../assets/header/FaqbottomBg.jpeg";
export const Home1 = {
  ARABIC: {
    heading1: "TCS Sustainathon",
    heading2: "قم بالتغيير من أجل غد أفضل",
    heading3: "<p>لحل مشاكل العالم الحقيقية </p>",
    imageTop: homeTopBackground,
    imageBottom: homeBottomBackground,
    bottom: true,
    launch: true,
    details: false,
  },
  ENGLISH: {
    heading1: "TCS Sustainathon",
    heading2: "Make the change for a better tomorrow",
    heading3:
      "<p>Create a sustainable future by using technology to solve real world problems!</p>",
    imageTop: homeTopBackground,
    imageBottom: homeBottomBackground,
    bottom: true,
    launch: true,
    details: false,
  },
};
export const Faqs = {
  ARABIC: {
    heading1: "الأسئلة المتكررة",
    heading2: "الأسئلة الشائعة",
    heading3: null,
    imageTop: faqTopBackground,
    imageBottom: faqBottomBackground,
    learn: false,
    bottom: true,
    details: false,
  },
  ENGLISH: {
    heading1: "Frequently Asked Questions",
    heading2: "FAQ",
    heading3: null,
    imageTop: faqTopBackground,
    imageBottom: faqBottomBackground,
    learn: false,
    bottom: true,
    details: false,
  },
};
export const EventSus = {
  ARABIC: {
    heading1: "TCS SUSTAINATHON",
    heading2: "أحداث",
    heading3: `Sustainathon
      هو المكان الذي تولد فيه الافكار، نقدم للمبتكرين الشباب الفرصة لحل المشكلات السياقية وأن يكونوا جزءًا من حدث كبير ومثير
      انتقل لأسفل للتحقق من فعالياتنا`,
    imageTop: EventTopBackground,
    imageBottom: null,
    bottom: true,
    launch: false,
    events: true,
    details: false,
  },
  ENGLISH: {
    heading1: "TCS SUSTAINATHON",
    heading2: "Events",
    heading3:
      "<p>Sustainathon is where ideas come to life! We offer young innovators a stage to solve contextual problems and be part of something big and exciting. Scroll down to check out our events</p>",
    imageTop: EventTopBackground,
    imageBottom: null,
    bottom: true,
    launch: false,
    events: true,
    details: false,
  },
};

export const SustainathonChallenges = {
  ARABIC: {
    heading1: "SUSTAINATHON 2021",
    heading2: "",
    heading3:
      "<p>Sustainathon هو المكان الذي تنبض فيه الأفكار بالحياة! نحن نقدم للمبتكرين الشباب منصة لحل المشكلات السياقية ويكونوا جزءًا من شيء كبير ومثير. قم بالتمرير لأسفل للتحقق من الأحداث لدينا</p>",
    imageTop: EventTopBackground,
    bottom: true,
    launch: false,
    events: false,
    details: true,
  },
  ENGLISH: {
    heading1: "SUSTAINATHON 2021",
    heading2: "",
    heading3:
      "<p>Sustainathon is where ideas come to life! We offer young innovators a stage to solve contextual problems and be part of something big and exciting. Scroll down to check out our events</p>",
    imageTop: EventTopBackground,
    bottom: true,
    launch: false,
    events: false,
    details: true,
  },
};
export const About = {
  ARABIC: {
    heading1: "ماهو Sustainathon",
    heading2: null,
    heading3: null,
    learn: false,
  },
  ENGLISH: {
    heading1: "What's Sustainathon",
    heading2: null,
    heading3: null,
    learn: false,
  },
};

export const AboutList = {
  ARABIC: [
    {
      Title: "قضايا الاستدامة في العالم الحقيقي",
      Desc: "قضايا العالم الحقيقي مع صياغة واضحة للوصول الى حلول واقعية وعملية.",
      img: change,
    },
    {
      Title: "الأفكار والابتكار",
      Desc: "تقارب الافكار والتكنولوجيا لتعظيم الاثر الايجابي للمجتمع. ",
      img: experts,
    },
    {
      Title: "قوة النظام البيئي ",
      Desc: "نظام بيئي من الخبراء المتخصصين في مجالات الاستدامة والتقنية والاعمال ",
      img: exposure,
    },
    {
      Title: "الناس في المركز ",
      Desc: "بدءًا من التفكير، والاحتضان، والتنفيذ، وحتى التأثير، كل فرد لديه دور يلعبه. ",
      img: rewards,
    },
  ],
  ENGLISH: [
    {
      Title: "Real-world sustainability issues",
      Desc: "Real-world issues with clear framing to drive for realistic and practical solutions.",
      img: change,
    },
    {
      Title: "Ideas & innovation",
      Desc: "Convergence of ideas and technology to amplify positive impact for the society.",
      img: experts,
    },
    {
      Title: "Power of ecosystem",
      Desc: "An ecosystem of subject-matter-experts from the sustainability, technical and business fields.",
      img: exposure,
    },
    {
      Title: "People in the center",
      Desc: "From ideation, incubation, implementation to impact, every one has a part to play.",
      img: rewards,
    },
  ],
};
